"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const elements_1 = require("@src/components/elements");
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const useAppMutation_1 = require("@src/hooks/useAppMutation");
const queries_1 = require("@src/types/queries");
const react_query_1 = require("react-query");
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const CancelSubscriptionModal = ({ selectedSubscriptionIdToCancel, setSelectedSubscriptionIdToCancel }) => {
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { mutateAsync: deleteLinkedScheduledJobsToPaymentSubscription, isLoading: isDeletingLinkedScheduledJobs } = (0, useAppMutation_1.useAppMutation)(Api.ScheduledJob.deleteLinkedScheduledJobsToPaymentSubscription);
    const cancelSubscriptionAndUpdateCompany = async () => {
        try {
            if (!selectedSubscriptionIdToCancel) {
                setSelectedSubscriptionIdToCancel(null);
                return;
            }
            await deleteLinkedScheduledJobsToPaymentSubscription({
                companyPaymentSubscriptionId: selectedSubscriptionIdToCancel,
            });
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
            setSelectedSubscriptionIdToCancel(null);
        }
        catch (err) {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'general.error',
                }),
                description: intl.formatMessage({
                    id: 'general.something_went_wrong',
                }),
            });
        }
    };
    return ((0, jsx_runtime_1.jsx)(elements_1.Modal, { centered: true, visible: Boolean(selectedSubscriptionIdToCancel), onCancel: () => setSelectedSubscriptionIdToCancel(null), confirmLoading: isDeletingLinkedScheduledJobs, onOk: cancelSubscriptionAndUpdateCompany, okText: intl.formatMessage({ id: 'admin.payments.payments_subscriptions.cancel_subscription' }), okType: "danger", title: intl.formatMessage({ id: 'admin.payments.payments_subscriptions.are_you_sure_to_cancel' }), children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.payments.payments_subscriptions.cancel_text" }) }));
};
exports.default = CancelSubscriptionModal;
